const url = "/api/v1/features";

export interface FeaturesShowParams {
  key: string;
}

export const featuresShowQuery = (params: FeaturesShowParams) => ({
  url: `${url}/${params.key}`,
  method: "GET",
});

export interface FeaturesShowResponse {
  enabled: boolean;
}
